import axios from "axios";

const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";
const runtimeHostname = typeof window !== "undefined" ? window.location.hostname : "";
const isPreviewHost = runtimeHostname.endsWith(".preview.emergentagent.com");
const isLocalHost = ["localhost", "127.0.0.1"].includes(runtimeHostname);
const useCurrentOriginForApi = Boolean(runtimeOrigin) && !isPreviewHost && !isLocalHost;

export const BACKEND_URL = useCurrentOriginForApi ? runtimeOrigin : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const authConfig = (config = undefined) =>
  config && typeof config === "object" && !Array.isArray(config)
    ? { withCredentials: true, ...config }
    : { withCredentials: true };

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((entry) => (entry && typeof entry.msg === "string" ? entry.msg : JSON.stringify(entry)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const skipRefresh = ["/auth/login", "/auth/logout", "/auth/refresh"].some((path) => originalRequest?.url?.includes(path));
    if (!originalRequest || originalRequest._retry || error.response?.status !== 401 || skipRefresh) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      await axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true });
      return api(originalRequest);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  },
);